/* ============================================================
   Merrytime Fireworks (SEA) — theme.js
   Vanilla JS, no jQuery. Wrapped in DOMContentLoaded.
   Features: age gate, mobile menu, accordions, variant select,
   quantity buttons, cart updates, order tracker, smooth scroll.
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initAgeGate();
    initNavDrawer();
    initDrawerAccordions();
    initVideoBanners();
    initQuantityButtons();
    initVariantSelectors();
    initProductThumbs();
    initOrderTracker();
    initSmoothScroll();
    initSortBy();
    initRecoverToggle();
    initCartRemove();
  });

  /* ---------- Age Gate ---------- */
  function initAgeGate() {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    var FLAG = 'merrytime_age_verified';
    if (localStorage.getItem(FLAG) === '1') return;

    gate.hidden = false;
    document.body.classList.add('age-gate--locked');

    var enter = gate.querySelector('[data-age-gate-enter]');
    var close = gate.querySelector('[data-age-gate-close]');

    function dismiss() {
      localStorage.setItem(FLAG, '1');
      gate.hidden = true;
      document.body.classList.remove('age-gate--locked');
    }
    if (enter) enter.addEventListener('click', dismiss);
    if (close) close.addEventListener('click', function () {
      window.location.href = 'https://www.google.com';
    });
  }

  /* ---------- Navigation Drawer (unified desktop + mobile) ---------- */
  function initNavDrawer() {
    var toggle = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    var backdrop = document.querySelector('[data-drawer-backdrop]');
    var closeBtn = drawer ? drawer.querySelector('[data-drawer-close]') : null;
    if (!toggle || !drawer) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.classList.toggle('is-open', open);
      if (open) drawer.hidden = false;
      if (backdrop) {
        backdrop.hidden = !open;
        backdrop.classList.toggle('is-visible', open);
      }
      document.body.classList.toggle('drawer-open', open);
      if (open) {
        var firstLink = drawer.querySelector('.drawer-nav__link');
        if (firstLink) {
          setTimeout(function () { firstLink.focus(); }, 50);
        } else if (closeBtn) {
          closeBtn.focus();
        }
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.drawer-nav__link') || e.target.closest('.drawer-logo')) {
        setOpen(false);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  }

  /* ---------- Drawer accordions (event delegation, multiple open allowed) ---------- */
  function initDrawerAccordions() {
    var nav = document.querySelector('.drawer-nav');
    if (!nav) return;
    nav.addEventListener('click', function (e) {
      var toggle = e.target.closest('.drawer-accordion__toggle');
      if (!toggle) return;
      e.preventDefault();
      var row = toggle.closest('.drawer-accordion');
      if (!row) return;
      var isOpen = row.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      // Do NOT close other accordions — multiple open allowed.
    });
  }

  /* ---------- Quantity Buttons ---------- */
  function initQuantityButtons() {
    document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Variant Selectors ---------- */
  function initVariantSelectors() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id-input]');
    var priceCurrent = document.querySelector('[data-price-current]');
    var priceCompare = document.querySelector('[data-price-compare]');
    var skuValue = document.querySelector('[data-sku-value]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = form.querySelector('[data-add-to-cart-label]');
    var stockBadge = document.querySelector('[data-stock-badge]');
    var notifyBlock = document.querySelector('[data-notify-whatsapp]');
    var moneyFormat = window.themeMoneyFormat || '{{ shop.money_format }}';

    function fmt(cents) {
      // Simple fallback: MYR format. Replace if theme exposes money format.
      return 'RM ' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      var selected = [];
      selects.forEach(function (s) { selected.push(s.value); });
      return (product.variants || []).find(function (v) {
        return (v.options || []).every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceCurrent) priceCurrent.textContent = fmt(v.price);
      if (priceCompare) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceCompare.textContent = fmt(v.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (skuValue) skuValue.textContent = v.sku || '-';
      var available = v.available !== false;
      if (addBtn) {
        addBtn.disabled = !available;
        form.setAttribute('data-variant-available', available ? 'true' : 'false');
      }
      if (addLabel) addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (notifyBlock) notifyBlock.hidden = available;
      if (stockBadge) {
        stockBadge.setAttribute('data-available', available ? 'true' : 'false');
        stockBadge.setAttribute('data-inventory-quantity', v.inventory_quantity != null ? v.inventory_quantity : '');
        var threshold = parseInt(stockBadge.getAttribute('data-threshold'), 10) || 5;
        var item = stockBadge.querySelector('.stock-badge__item');
        if (item) {
          item.classList.remove('stock-badge--instock', 'stock-badge--low', 'stock-badge--soldout');
          if (!available) {
            item.classList.add('stock-badge--soldout');
            item.textContent = 'Sold Out';
          } else if (v.inventory_quantity != null && v.inventory_quantity <= threshold) {
            item.classList.add('stock-badge--low');
            item.textContent = 'Low Stock — only ' + v.inventory_quantity + ' left';
          } else {
            item.classList.add('stock-badge--instock');
            item.textContent = 'In Stock';
          }
        }
      }
      // Update inventory bar
      var inv = document.querySelector('[data-inventory-status]');
      if (inv) {
        var bar = inv.querySelector('[data-stock-bar-fill]');
        var max = parseInt(inv.getAttribute('data-max'), 10) || 50;
        var qty = v.inventory_quantity != null ? v.inventory_quantity : max;
        var pct = Math.min(100, Math.round((qty / max) * 100));
        if (bar) bar.style.width = pct + '%';
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Product Thumbnails (image + video media panels) ---------- */
  function initProductThumbs() {
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!thumbs.length) return;
    var panels = document.querySelectorAll('[data-media-panel]');
    var main = document.querySelector('[data-main-image]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var idx = t.getAttribute('data-media-index');
        if (idx != null && panels.length) {
          panels.forEach(function (p) {
            var active = p.getAttribute('data-index') === idx;
            p.classList.toggle('is-active', active);
            if (!active) {
              var v = p.querySelector('video');
              if (v) { try { v.pause(); } catch (e) {} }
            }
          });
        } else if (main && t.getAttribute('data-image')) {
          main.src = t.getAttribute('data-image');
        }
      });
    });
  }

  /* ---------- Video Banners: custom play button reveal ---------- */
  function initVideoBanners() {
    document.querySelectorAll('[data-video-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var banner = btn.closest('[data-video-banner]');
        if (!banner) return;
        var iframe = banner.querySelector('[data-video-iframe]');
        var video = banner.querySelector('[data-video-element]');
        if (iframe && iframe.getAttribute('data-src')) {
          iframe.src = iframe.getAttribute('data-src');
        }
        if (video) {
          try { video.muted = false; video.play(); } catch (e) { try { video.play(); } catch (e2) {} }
        }
        btn.style.display = 'none';
        // Pause any other playing videos when one starts
        document.querySelectorAll('video[data-video-element]').forEach(function (other) {
          if (other !== video) { try { other.pause(); } catch (e) {} }
        });
      });
    });
  }

  /* ---------- Order Tracker ---------- */
  function initOrderTracker() {
    var form = document.querySelector('[data-order-tracker-form]');
    var result = document.querySelector('[data-order-tracker-result]');
    if (!form || !result) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('[data-order-name]').value.trim();
      var contact = form.querySelector('[data-order-contact]').value.trim();
      if (!name || !contact) return;

      result.hidden = false;
      var nameEl = result.querySelector('[data-result-order-name]');
      if (nameEl) nameEl.textContent = name;

      // Deterministic pseudo-status based on order name length (client-side demo).
      // In production this calls a tracking app endpoint.
      var steps = ['pending', 'whatsapp', 'packed', 'shipped', 'delivered'];
      var idx = Math.min(steps.length - 1, Math.max(0, (name.length % steps.length)));
      steps.forEach(function (s, i) {
        var el = result.querySelector('[data-step="' + s + '"]');
        if (!el) return;
        el.classList.remove('is-done', 'is-current');
        if (i < idx) el.classList.add('is-done');
        else if (i === idx) el.classList.add('is-current', 'is-done');
      });

      var carrier = result.querySelector('[data-carrier-link]');
      if (carrier) {
        if (idx >= 3) {
          carrier.hidden = false;
          carrier.href = '#'; // carrier tracking URL placeholder
        } else {
          carrier.hidden = true;
        }
      }
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- Smooth Scroll for anchor links ---------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---------- Sort By (collection) ---------- */
  function initSortBy() {
    var sel = document.querySelector('[data-sort-by]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Recover password toggle on login ---------- */
  function initRecoverToggle() {
    var link = document.querySelector('a[href="#recover"]');
    var form = document.querySelector('#recover');
    if (!link || !form) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      form.hidden = !form.hidden;
    });
  }

  /* ---------- Cart remove (client-side optimistic) ---------- */
  function initCartRemove() {
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-line-index');
        var input = document.querySelector('[data-qty-input][data-line-index="' + idx + '"]');
        if (input) {
          input.value = 0;
          input.closest('form').submit();
        }
      });
    });
  }
})();
